import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalConfigurationLevelActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Level/LevelBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalConfigurationLevel"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalConfigurationLevel"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalConfigurationLevelActivity)
